import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GlobalVar } from '../globals/global-var';
import { Customer } from '../models/customer';
import { Roster } from '../models/roster';

@Injectable({
  providedIn: 'root'
})
export class CheckinService {

  constructor(private http: HttpClient, private globalVar: GlobalVar) { }

  postStaffLoginApi(loginView): Observable<any> {
    return this.http.post<any>(this.globalVar.targetIp + '/api/Checkin/Signin', loginView);
  }

  getRosterListApi(date: string): Observable<Roster[]> {
    return this.http.get<Roster[]>(this.globalVar.targetIp + '/api/Checkin/Roster', { params: { date: date } });
  }

  getRosterApi(id: number): Observable<Roster> {
    return this.http.get<Roster>(this.globalVar.targetIp + '/api/Checkin/Roster/' + id);
  }

  getCustomerApi(id: string): Observable<Customer> {
    return this.http.get<Customer>(this.globalVar.targetIp + '/api/Checkin/customer/' + id);
  }

  putRosterStateApi(id: number, rosterState: any): Observable<any> {
    return this.http.put<any>(this.globalVar.targetIp + '/api/Checkin/roster/' + id + '/state', rosterState);
  }

  putRosterMemoApi(id: number, rosterMemo: any): Observable<any> {
    return this.http.put<any>(this.globalVar.targetIp + '/api/Checkin/roster/' + id + '/memo', rosterMemo);
  }


  logout() {
    sessionStorage.removeItem('authSystem_token');
    sessionStorage.removeItem('authSystem_checker');
    this.globalVar.checker = null;
  }
}
